<template>
  <div>
    <b-card 
      text-variant="white" 
      header="Evolución Signos Vitales" 
      header-bg-variant="primary"
      border-variant="info"
      
    >

      <b-row class="mt-2 d-flex align-items-center justify-content-around"> 
        <b-card class="col-5" border-variant="warning">
          <LineChartGenerator 
            :chart-options="chartOptions" 
            :chart-data="chartData" 
            :chart-id="chartId"
            :dataset-id-key="datasetIdKey" 
            :plugins="plugins" 
            :css-classes="cssClasses" 
            :styles="styles"
            :width="width" 
            :height="height" 
          />

        </b-card>
        

        <b-card class="col-5" border-variant="primary">
          <LineChartGenerator 
            :chart-options="chartOptions" 
            :chart-data="chartDataPeso"
            :chart-id="chartId" 
            :dataset-id-key="datasetIdKey" 
            :plugins="plugins"
            :css-classes="cssClasses" 
            :styles="styles" 
            :width="width" 
            :height="height" 
          />
        </b-card>


        <b-card class="col-5" border-variant="info">
          <LineChartGenerator 
            :chart-options="chartOptions" 
            :chart-data="chartDataTalla"
            :chart-id="chartId" 
            :dataset-id-key="datasetIdKey" 
            :plugins="plugins"
            :css-classes="cssClasses" 
            :styles="styles" 
            :width="width" 
            :height="height" 
          />
        </b-card>

      </b-row>
    </b-card>


  </div>
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {

  name: "ChartSignosVitales",


  components: {
    LineChartGenerator
  },

  props: {
    historialSignos: Array,

    chartId: {
      type: String,
      default: 'line-chart'
    },

    datasetIdKey: {
      type: String,
      default: 'label'
    },

    width: {
      type: Number,
      default: 500
    },

    height: {
      type: Number,
      default: 500
    },

    cssClasses: {
      default: '',
      type: String
    },

    styles: {
      type: Object,
      default: () => { }
    },

    plugins: {
      type: Array,
      default: () => []
    }
  },


  created() {
    this.fetchData()
  },

  data() {
    return {
      esPediatrico: false,
      
      chartData: {
        datasets: []
      },

      chartDataPeso: {
        datasets: []
      },

      chartDataTalla: {
        datasets: []
      },

      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              stepSize: 0.5,
              callback: (value) =>  value.toFixed(1)
            }
          }
        }
      }
    }
  },


  methods: {
    fetchData() {

      const dataSignos = [...this.historialSignos]
      dataSignos.sort( (a, b) => new Date(a.fecha) - new Date(b.fecha) );

      const fechas = dataSignos.map(s => s.fecha);
      const signos = dataSignos.map(s => s.signosVitales);

      const pesos  = signos.map(s => s.peso);
      const imcs   = signos.map(s => s.imc);
      const tallas = signos.map(s => s.talla);

      this.chartData.labels      = fechas;
      this.chartDataPeso.labels  = fechas;
      this.chartDataTalla.labels = fechas;

      this.chartData.datasets.push(
        {
          label: 'IMC (Indice Masa Corporal)',
          backgroundColor: '#f4c284',
          data: imcs
        },
      )

      this.chartDataPeso.datasets.push(
        {
          label: "Peso (Kilogramos)",
          backgroundColor: '#84b6f4',
          data: pesos
        },
      )

      this.chartDataTalla.datasets.push(
        {
          label: "Talla (Centimetros)",
          backgroundColor: '#84b6f4',
          data: tallas
        },
      )
    }
  }
}
</script>
